import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const PieChart = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C8.275 2 2 8.275 2 16C2 23.725 8.275 30 16 30C23.725 30 30 23.725 30 16C30 8.275 23.725 2 16 2ZM27.962 15H17V4.037C22.825 4.524 27.475 9.175 27.962 15ZM15 4.037V15.574L6.838 23.749C5.075 21.649 4 18.949 4 15.999C4 9.724 8.85 4.549 15 4.036V4.037ZM16 28C13.05 28 10.35 26.925 8.25 25.163L16.413 17H27.951C27.451 23.15 22.276 28 16.001 28H16Z" />
	</svg>
);

export default PieChart;
